import { Episode } from "../types/incapacity";

export type EpisodeWindowStatus = "Ongoing" | "Upcoming" | "Ended";

export const toLocalDateKey = (value: Date) => {
  const year = value.getFullYear();
  const month = String(value.getMonth() + 1).padStart(2, "0");
  const day = String(value.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

const toDateKeyFromIso = (value: string | null) => {
  if (!value) {
    return null;
  }

  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) {
    return null;
  }

  return toLocalDateKey(parsed);
};

export const formatDate = (value: string | null) => {
  if (!value) {
    return "-";
  }

  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) {
    return value;
  }

  return new Intl.DateTimeFormat(undefined, {
    year: "numeric",
    month: "short",
    day: "2-digit",
  }).format(parsed);
};

export const formatDateTime = (value: string | null) => {
  if (!value) {
    return "-";
  }

  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) {
    return value;
  }

  return new Intl.DateTimeFormat(undefined, {
    year: "numeric",
    month: "short",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  }).format(parsed);
};

export const getEpisodeWindowStatus = (
  episode: Episode,
  todayKey: string,
): EpisodeWindowStatus => {
  const startDateKey = toDateKeyFromIso(episode.startDate);
  const returnDateKey = toDateKeyFromIso(episode.returnDate);

  if (startDateKey && startDateKey > todayKey) {
    return "Upcoming";
  }

  if (startDateKey && startDateKey <= todayKey) {
    if (!returnDateKey || returnDateKey >= todayKey) {
      return "Ongoing";
    }
  }

  return "Ended";
};

export const statusBadgeClassName = (status: EpisodeWindowStatus) => {
  if (status === "Upcoming") {
    return "statusBadgeUpcoming";
  }

  if (status === "Ended") {
    return "statusBadgeEnded";
  }

  return "statusBadgeOngoing";
};

/** True while the episode is currently active or scheduled to start. */
export const isActiveEpisode = (episode: Episode, todayKey: string) => {
  const status = getEpisodeWindowStatus(episode, todayKey);
  return status === "Ongoing" || status === "Upcoming";
};
